import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    homePageImage_root: {
      gridColumnStart: "left",
      gridRowStart: "top",
      gridRowEnd: "bottom",
      zIndex: 0
    }
  });
});
